export default __webpack_public_path__ + "static/media/verlinde-banner-desktop.98ef010b.png";